import {
  SET_REACTIVE_HT,
  SET_REACTIVE_LT,
} from '../mutationTypes';

const moduleReactive = {
  namespaced: true,

  state: {
    reactiveCalculationData: {
      reactiveHT: 0,
      reactiveLT: 0,
    },
  },

  getters: {

  },

  actions: {

  },

  mutations: {
    [SET_REACTIVE_HT](state, payload) {
      state.reactiveCalculationData.reactiveHT = payload;
    },
    [SET_REACTIVE_LT](state, payload) {
      state.reactiveCalculationData.reactiveLT = payload;
    },
  },
};

export default moduleReactive;

